import { useCallback, useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { Icon } from '~/components';
import { Button } from '~/components/Button';
import { Modal } from '~/components/Modal';

function FeedbackRequestModal() {
  const { t } = useTranslation('roster');

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const hasViewedFeedbackRequestModal = localStorage.getItem(
      'hasViewedFeedbackRequestModal',
    );

    if (!hasViewedFeedbackRequestModal) {
      setIsOpen(true);
      localStorage.setItem('hasViewedFeedbackRequestModal', 'true');
    }
  }, []);

  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  return isOpen ? (
    <Modal onClose={handleClose} isOpen={true}>
      <div className="flex flex-col gap-md rounded-sm p-xl bg-default text-white">
        <div className="flex items-center justify-between align-middle">
          <div className="flex items-center gap-sm align-middle">
            <Icon type="comment-lines" variant="solid" size="md" />
            <span className="text-headline-md font-semibold">
              {t('preReleases.feedbackRequestModal.title')}
            </span>
          </div>
        </div>
        <div className="text-body-md text-subtle">
          <Trans
            t={t}
            i18nKey="preReleases.feedbackRequestModal.message"
            components={{ br: <br /> }}
          />
        </div>

        <img
          className="w-[488px]"
          src="/images/prerelease-feedback-request-modal-content.png"
          alt={t('preReleases.feedbackRequestModal.image-alt')}
        />

        <div className="flex justify-end space-x-lg">
          <Button
            variant="primary"
            size="large"
            onClick={(event) => {
              event.stopPropagation();
              handleClose();
            }}
          >
            {t('preReleases.feedbackRequestModal.ok')}
          </Button>
        </div>
      </div>
    </Modal>
  ) : null;
}

FeedbackRequestModal.displayName = 'FeedbackRequestModal';

export { FeedbackRequestModal };
